<template>
  <div class="hello">
    <div class="subTitle">泸州天立</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'lztl',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=qrNnmFAR6Gd8f37edaf21f4373OJZbEtuO9RbhFS7vWxzAJJn7taWtZ7XvlpxAhA7GmxYM0rh/7FnOQtj0SLNlizo1MEJvl0YAzJFd8o6xHYcE5T9RmgslMjlDYST9PPKd/5HEcWxuCThCQW'
        },
        {
          label: '综合服务费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM55u3d2v98Y+9ld9I4dDCAyfyGfO1PplN6gkIH5lgsNUHm4wHW1RrI1/w0UWCp4shiLlMSitozmMG67NI5baX+boTAsLygDbzcNbuEN72ylNtL5YWsmfvWpzYMnIUtEUAjuKB/yVmiSPy3mOGeVcE5s='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '泸州天立';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

